import { Box } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import MaintenanceDashboard from '../MaintenanceDashboard';

/**
 * The Thread style of the maintenance manager home: work orders as steps from reported to done, with the preventive maintenance due this week on the side.
 * The server narrows everything to the caller's own records and leaves out any section the caller has no key for, so this stays a thin wrapper.
 */
export default function MaintenanceLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.maintenance">
            <RoleLensBoard institutionId={institutionId} lens="maintenance" fallback={<MaintenanceDashboard />} />
        </Box>
    );
}
